import Clarity from '@microsoft/clarity'

interface ClarityConfig {
  projectId: string
}
interface Payload {
  event: string
}

/** Vite plugin that injects and initialises the Microsoft Clarity analytics script. */
export default function clarityPlugin(userConfig: { projectId: string; enabled: boolean }) {
  return {
    name: 'clarity-plugin',
    config: {
      projectId: userConfig.projectId,
    },
    initialize: ({ config }: { config: ClarityConfig }) => {
      if (userConfig.enabled) {
        Clarity.init(config.projectId)
      }
    },
    track: ({ payload }: { payload: Payload }) => {
      if (userConfig.enabled) {
        Clarity.event(payload.event)
      }
    },
    loaded: () => {
      if (window?.clarity) {
        return true
      }
    },
  }
}
